module.exports = __webpack_public_path__ + "assets/01fcfe87b17a284969cc9901ac4f934c.mp3";